// Clamp
export default function (number, min, max) {
	return Math.max(min, Math.min(number, max));
}
